@use 'themes/westfield' as *;
// Common field styles
// ===================

@use 'tools/dirg' as *;
@use 'tools/color' as *;
@use 'tools/if-theme' as *;
@use 'tools/typography.module' as *;

.field {
  @include font-size(2);

  @extend .bodyFont;
  width: 100%;
  height: units(3);
  background: color('surfaceTertiary');
  color: color('Black');
  padding: units(0.5) units(1);
  border: 1px solid color('Grey Dark');

  @include if-theme('scentregroup') {
    border-radius: 3px;
  }

  &:active,
  &:focus {
    border-color: color('Grey Dark');

    @include if-theme('scentregroup') {
      border-color: color('Black');
      box-shadow: 0 0 4px rgba(color('Black'), 0.4);
    }
  }

  &::placeholder {
    color: rgba(color('Black'), 0.5);
  }
}

.fieldSmall {
  @include font-size(1);

  @extend .bodyFont;
  width: 100%;
  height: units(2.5);
  background: color('surfaceTertiary');
  color: color('Black');
  padding: units(0) units(0.5);
  border: 1px solid color('Grey Dark');

  &:active,
  &:focus {
    border-color: color('Grey Dark');
  }

  &::placeholder {
    color: rgba(color('Black'), 0.5);
  }
}

.fieldInvalid {
  border-color: color('Error');
  background: color('Error Light');

  &:active,
  &:focus {
    border-color: color('Error');

    @include if-theme('scentregroup') {
      box-shadow: 0 0 4px rgba(color('Error'), 0.4);
    }
  }
}

.fieldWrapper {
  display: inline-flex;
  flex-basis: auto;
  flex-flow: column nowrap;
  align-items: flex-start;
}

.fieldIconContainer {
  position: relative;
  width: 100%;
}

* + .fieldIconContainer {
  margin-top: units(0.5);
}

.fieldHorizontal {
  flex-direction: row;
}

.horizontalLabelWrapper {
  min-width: columns(2);
}

.horizontalFieldWrapper {
  margin-top: units(0);
  margin-left: units(1);
  width: 100%;
}
